module.exports = __webpack_public_path__ + "static/media/brev-b.ff0685b2.mp3";